import React from 'react';
import { InputTextarea } from 'primereact/inputtextarea';
import { Checkbox } from 'primereact/checkbox';
import { Dropdown } from 'primereact/dropdown';

export type Step4Props = {
  descTemplate: string;
  setDescTemplate: (v: string) => void;
  descText: string;
  setDescText: (v: string) => void;
  descTemplateOptions: { label: string; value: string }[];
  attachedDescription: string;
  descBodyLoading?: boolean;
  showDescriptionInAcord101: boolean;
  setShowDescriptionInAcord101: (v: boolean) => void;
  onSearchTemplates?: (query: string) => void;
  descTemplatesLoading?: boolean;
};

const Step4: React.FC<Step4Props> = ({
  descTemplate,
  setDescTemplate,
  descText,
  setDescText,
  descTemplateOptions,
  attachedDescription,
  descBodyLoading = false,
  showDescriptionInAcord101,
  setShowDescriptionInAcord101,
  onSearchTemplates,
  descTemplatesLoading = false,
}) => {
  return (
    <div className="page">
      <div className="page__sectionHeader">
        <div>
          <h2 className="page__title">Description of Operations</h2>
          <p className="page__muted">Provide or select a description of operations</p>
        </div>
      </div>
      <div className="page__twoCol" style={{ gridTemplateColumns: '1fr' }}>
        <div className="pageCard" style={{ padding: 16, display: 'flex', flexDirection: 'column', gap: 16 }}>
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
              <Checkbox inputId="showAcord101" checked={showDescriptionInAcord101} onChange={e => setShowDescriptionInAcord101(e.checked ?? false)} />
              <label htmlFor="showAcord101" className="page__muted" style={{ fontWeight: 500 }}>
               Show description in ACORD 101
              </label>
            </div>

          </div>
          <div>
            <div className="page__muted" style={{ marginBottom: 4 }}>Select template</div>
            <Dropdown
              value={descTemplate || null}
              options={descTemplateOptions}
              onChange={e => setDescTemplate(e.value ?? '')}
              placeholder="Select a template"
              style={{ width: '100%' }}
              appendTo={document.body}
              emptyMessage={descTemplatesLoading ? 'Searching...' : 'No available options'}
              filter
              filterPlaceholder="Search templates..."
              onFilter={(e) => onSearchTemplates?.(e.filter)}
            />
          </div>
          <div>
            <div className="page__muted" style={{ marginBottom: 4 }}>Description</div>
            <div style={{ position: 'relative' }}>
              <InputTextarea
                maxLength={2000}
                value={descBodyLoading ? '' : descText}
                onChange={e => setDescText(e.target.value)}
                rows={6}
                placeholder={descBodyLoading ? '' : 'Enter description of operations...'}
                style={{ width: '100%', opacity: descBodyLoading ? 0.4 : 1 }}
                disabled={descBodyLoading}
              />
              {descBodyLoading && (
                <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', pointerEvents: 'none' }}>
                  <i className="pi pi-spin pi-spinner" style={{ fontSize: 22, color: '#381574' }} />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Step4;
